module.exports = __webpack_public_path__ + "static/media/cost.b0260855.svg";